import { Button } from '@appsumo/dorado-react';
import Link from 'next/link';
import { useContext } from 'react';

import CommentList from './sidebar/CommentList';
import DealRatings from './sidebar/DealRatings';
import ProductDetails from './sidebar/ProductDetails';

import { DiscussionType } from '~/lib/discussions/types';
import { DISCUSSION } from '~/lib/discussions/constants';
import { PDPContext } from '~/lib/product/context';

function DiscussionSidebar({
  deal,
  discussionSlug = DISCUSSION.QUESTIONS,
}: {
  deal: any;
  discussionSlug?: DiscussionType;
}) {
  const { userStatus } = useContext(PDPContext);
  const discussionType =
    discussionSlug === DISCUSSION.REVIEWS ? 'reviews' : 'questions';

  return (
    <aside className="w-[400px] min-w-[400px] pb-8 max-sm:w-full max-sm:min-w-full">
      <ProductDetails deal={deal} />

      {discussionSlug === DISCUSSION.REVIEWS && <DealRatings deal={deal} />}

      <CommentList
        title="Latest questions"
        prefix={`/products/${deal.slug}/`}
        comments={deal.top_5_questions}
      />

      <hr />

      <CommentList
        title="Latest reviews"
        prefix={`/products/${deal.slug}/`}
        comments={deal.top_5_reviews}
      />

      <hr />

      <Link
        href={`/products/${deal.slug}/${discussionType}`}
        className="my-4 text-bolt line-clamp-2 hover:underline"
      >
        See all {discussionSlug} for this product
      </Link>

      <Button
        href={`/products/${deal.slug}/#${discussionSlug}`}
        disabled={
          discussionSlug === DISCUSSION.REVIEWS &&
          !userStatus?.user_has_purchased
        }
        secondary
      >
        {discussionSlug === DISCUSSION.REVIEWS
          ? 'Leave a review'
          : 'Ask a question'}
      </Button>
    </aside>
  );
}

export default DiscussionSidebar;
